import React from 'react';
import { Layout, Text, Icon, Card, Button} from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { FlatList, Platform } from 'react-native';
import { OrganizationCard, CardItem, ItemTypeHeader } from '../../components/list-items/CardItem';
import { Q_GET_ORGANIZATIONS } from '../../data/api/query/q_organizations';
import { Organization } from '../../data/models/types';



const PAGE_PADDING: number = Platform.OS === 'web' ? 60 : 0;


export function OrganizationScreen({ navigation, route }): React.ReactElement {
    const params = route?.params;
    console.log({ navigation, route, params });
    const group_id: string = params.group_id;
    const queryParams: any = {
        org_id: group_id,
    };
    console.log('using params', queryParams);
    const { loading, error, data } = useQuery(Q_GET_ORGANIZATIONS, {
        variables: queryParams,
        fetchPolicy: 'network-only'
    });


    if (loading) return <Text>Loading...</Text>;
    if (error)  {
        console.log('useQuery', error);
        return <Text>Error :(</Text>
    };
    console.log('we have data, ', data)
    const organization: Organization = data.organizations[0];
    const renderHeader = (): React.ReactElement => (
        <Card>
            <ItemTypeHeader title='GROUP' icon='layers-outline' />
            <Text category='h2'>{organization.title}</Text>
            <Text category='s1'>{organization.description}</Text>
            <Text category='p1'>You have {`${data.organizations.length} group${data.organizations.length === 1 ? '' : 's'}`}</Text>
        </Card>
    );
    const renderFooter = (): React.ReactElement => (
        <Card>
            <Text category='p1'>{'\n'}</Text>
        </Card>
    );
    const renderOrganization = ({ item }) => (
        <OrganizationCard
            item={item}
            onPress={() => navigation.navigate('Group', { group_id: item.id })}
            // style={{ height: 200 }}
            // style={[{ marginRight: 10 }]}
        />
    );
    const keyExtractor = (item: CardItem) => item.id;


    return (
        <Layout level='3' style={{ flex: 1, padding: PAGE_PADDING }}>
            <FlatList
                data={data.organizations}
                renderItem={renderOrganization}
                style={{ flex: 1 }}
                keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
            />
        </Layout>
    );
}